import gsap, { SplitText, ScrollTrigger } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element: HTMLElement, dataset: any) {
  let sel = gsap.utils.selector(element);
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 40%",
      end: "top top",
      scrub: true,
    },
    defaults: {
      ease: "none",
    },
  });

  tl.to(sel(".apply_bg"), {
    width: "100%",
    stagger: 0.5,
  });
}
